import React, {Component, SyntheticEvent} from 'react';

import {sendDesktopAnalyticsEvent} from '@optimaxdev/analytics/desktop/lib/sendAnalyticsEvent/index';
import {Modal, zIndex} from '@optimaxdev/design-system';
import classNames from 'classnames';

import {InnerHtml} from 'components/innerHtml/innerHtml';
import {CART_SECTION} from 'constants/analytics/events/cart';
import {apiConfig} from 'libs/api/api';

import styles from './specialOffer.scss';

export type PropsType = {
    specialOffer: string;
};

/**
 * Please remove it when it is in MASTER branch and make sure PMs are aware of this removing
 * @type {string} Offers class for content managers
 */
const OFFERS_CLASS = 'responsive-cart-reminder';

/**
 * Custom html code for left block in cart (banner)
 */
export class SpecialOffer extends Component<
    PropsType,
    {popupIsVisible: boolean; popupContent: string; cmsBlocksPopups: Record<any, any> | null}
> {
    state = {
        cmsBlocksPopups: null,
        popupContent: '',
        popupIsVisible: false,
    };

    /**
     * Fetching the content for popup
     * @param {string} cmsBlockName Block's id
     */
    fetchSpecialOfferPopup = (cmsBlockName: string) => {
        if (
            !this.state.cmsBlocksPopups ||
            typeof this.state.cmsBlocksPopups[cmsBlockName] === 'undefined'
        ) {
            apiConfig
                .instanceGusaBackend({
                    method: 'get',
                    url: `optimaxcart/react/getBanner/?blockCode=${cmsBlockName}`,
                })
                .then(response => {
                    /* istanbul ignore next */
                    if (response.status === 200) {
                        const cmsBlocksPopups: Record<any, any> = Object.assign(
                            {},
                            this.state.cmsBlocksPopups,
                        );

                        cmsBlocksPopups[cmsBlockName] = response.data.content;

                        this.setState({cmsBlocksPopups, popupContent: response.data.content});
                        this.changePopupVisibility(true);
                    }
                })
                .catch(() => console.error("Can't load popup cms block popup")); // eslint-disable-line
        } else {
            this.setState({popupContent: this.state.cmsBlocksPopups[cmsBlockName]});
            this.changePopupVisibility(true);
        }
    };

    /**
     * Try to fetch data if target element has data attribute
     * @param {SyntheticEvent<HTMLButtonElement>} event Event object
     */
    clickHandler = (event: SyntheticEvent<HTMLButtonElement>) => {
        let cmsBlockName;
        const nodeWithCmsBlockNameData = event.currentTarget.querySelector('[data-cms-block]');

        if (nodeWithCmsBlockNameData !== null) {
            cmsBlockName = nodeWithCmsBlockNameData.getAttribute('data-cms-block');
        }

        if (cmsBlockName) {
            this.fetchSpecialOfferPopup(cmsBlockName);
        }

        sendDesktopAnalyticsEvent(CART_SECTION, {
            label: 'Learn More - Coupon',
            section: 'Right',
        });
    };

    /**
     * Change visibility of popup
     * @param {boolean} visibility Value of popup visibility
     */
    changePopupVisibility = (visibility: boolean) => {
        this.setState({popupIsVisible: visibility});
    };

    /**
     * Render jsx to html
     */
    render() {
        const {specialOffer} = this.props;
        const {popupContent, popupIsVisible} = this.state;

        return specialOffer ? (
            <div data-test-name="summary">
                <button
                    className={classNames(styles.personalCoupons, OFFERS_CLASS)}
                    onClick={this.clickHandler}
                    type="button"
                >
                    <InnerHtml html={specialOffer} />
                </button>
                <Modal
                    isOpen={popupIsVisible}
                    onRequestClose={() => this.changePopupVisibility(false)}
                    overlay="dark"
                    zIndex={zIndex.popup}
                >
                    <InnerHtml html={popupContent} />
                </Modal>
            </div>
        ) : null;
    }
}
